import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbExtractAssessmentScore, bbExtractLastAssessmentDateAndBy, bbFormattedDateString,
    bbIsObject,
    mapObject
} from "../../../util/bbHelpers";
import {
    fetchComplianceAssessmentsAction,
    fetchComplianceStandardsAction,
    fetchCustomers, fetchPerimeterAttacksMetaAction,

} from "../../../actions";
import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import Tooltip from "@material-ui/core/Tooltip";
import BBDataTable from "../tables/BBDataTable";
import BBIconConstructionCone from "../../../assets/bbCustomIcons/BBIconConstructionCone";
import ComplianceAssessmentToggleSwitch from "../controllers/ComplianceAssessmentToggleSwitch";
import BBIconShieldCheck from "../../../assets/bbCustomIcons/BBIconShieldCheck";
import BBIconSextantMeasure from "../../../assets/bbCustomIcons/BBIconSextantMeasure";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import BBExternalLink from "../accents/BBExternalLink";

const TableContainer = (props) => {

    const {customerId, complianceStandardId, tableTitle, tableTip} = props;

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
  const {customers, loadingCustomers, customerInView} = useSelector(({customer}) => customer);
  const {
      complianceStandards,
      loadingComplianceStandards,
      customerAssessments,
      loadingCustomerAssessments,
  } = useSelector(({compliance}) => compliance);
  const dispatch = useDispatch();
  //select the customer from the store if it exists, based on the props customerId
  const customer = customers ? customerId ? customers[customerId] : customerInView ? customers[customerInView] : null : null;
    const assessments = customerAssessments ? customerAssessments[customerId] ? customerAssessments[customerId] : null : null;
  //from the customer, pull the ACTIVE target data if it exists

    const complianceStandardUrl = complianceStandards ? complianceStandards[complianceStandardId] ? complianceStandards[complianceStandardId].Url : null : null;

    const standardControls =  (standardId) => {
        //open up the standards
        // console.log("about to evaluate the complianceStandards", complianceStandards);
        if(complianceStandards
            && complianceStandards[standardId]
            && complianceStandards[standardId].Categories)
        {
            const standard = complianceStandards[standardId];
            //check each subcategory for controls
            const controls = {}
            for (const categoryId in standard.Categories) {
                for (const subCategoryId in standard.Categories[categoryId].Subcategories) {
                    for (const controlId in standard.Categories[categoryId].Subcategories[subCategoryId].Controls) {
                        controls[controlId] = standard.Categories[categoryId].Subcategories[subCategoryId].Controls[controlId];
                    }
                }
            }

            // console.log("got all of the controls, returning", controls)
            return controls;

        } else {
            // console.log("controls serach failed before start", complianceStandards)
            return {};
        }
    }

    const cmmcStandardControls = standardControls(complianceStandardId);

  useEffect(() => {
      console.log("customerId", customerId, "loadingMetaAttacks", "loadingCustomerAssessments", loadingCustomerAssessments, "loadingComplianceStandards", loadingComplianceStandards, "assessments", assessments)


      if (!customers && !loadingCustomers) {
          console.log("Customers is empty, fetching.")
          dispatch(fetchCustomers());
      } else if (customer && complianceStandards === null && !loadingComplianceStandards) {
          console.log("vectors is empty, fetching vectors for customerId = ", customer.CustomerId);
          dispatch(fetchComplianceStandardsAction());
      } else if (customer && !assessments && !loadingCustomerAssessments) {
          dispatch(fetchComplianceAssessmentsAction({
              customerId: customer.CustomerId,
              standardId: complianceStandardId,
          }));
      }

    // console.groupEnd()
  }, [dispatch, customers, customerInView, loadingCustomers, complianceStandards, loadingComplianceStandards, assessments, complianceStandardId, customer,
  loadingCustomerAssessments]);

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <div className={""}>
        {tableTitle} <Tooltip title={tableTip}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </div>;

  const userTableHeadings = [
      //{ field: 'customerId', headerName: 'CID', hide: true, flex : 1, sortable: true, type: 'string', },
      // { field: 'id', headerName: 'BreachBits Control ID', hide: true, flex : 2, sortable: true, type: 'string', },
      { field: 'levelAbbreviation', headerName: `ML`, hide: true, width : 55, sortable: true, type: 'string',  renderCell: (params) => (
              <Tooltip
                  title={`${params.row.levelName} - ${params.row.levelDescription}`}
              >
                  <a rel="noreferrer" target="_blank" href={params.value.Url ? params.value.Url : complianceStandardUrl}>
                      {params.value}
                  </a>
              </Tooltip>
          )},
      { field: 'standardControlId', headerName: `Practice ID`, hide: false, width : 128, sortable: true, type: 'string',
          renderCell: (params) => (

              renderCellExpand(params,
                  <BBExternalLink
                      href={params.value.Url ? params.value.Url : complianceStandardUrl}
                      tipText={params.value}
                  >
                      {params.value}
                  </BBExternalLink>

              )
          )},
      { field: 'category', headerName: `Domain`, hide: false, flex : 1.1, sortable: true, type: 'string', renderCell: (params) => (
              renderCellExpand(params, params.value.hasOwnProperty("Url")
                  ?<BBExternalLink href={params.value.Url}>{params.value}</BBExternalLink>
                  : params.value

              )
          )
      },
      { field: 'subcategory', headerName: `Capability`, hide: false, flex : 1.5, sortable: true, type: 'string', renderCell: (params) => (
              renderCellExpand(params, params.value.hasOwnProperty("Url")
                  ?<BBExternalLink href={params.value.Url}>{params.value}</BBExternalLink>
                  : params.value

              )

          )},
      { field: 'name', headerName: `Practice`, hide: false, flex : 3, sortable: true, type: 'string', renderCell: (params) => (
          renderCellExpand(params, params.value.hasOwnProperty("Url")
                          ?<BBExternalLink href={params.value.Url}>{params.value}</BBExternalLink>
                          : params.value

              )
          )},

      // { field: 'selfAttestations', headerName: 'Attestations', hide: false, flex : 0.75, sortable: true, type: 'string',
      //     valueGetter: (params) => (
      //         params.getValue('selfAssessment')
      //     ),
      //     renderCell: (params) => (
      //         <>
      //             {/*<Tooltip*/}
      //             {/*    title={params.getValue('lastAssessment')*/}
      //             {/*        ? `You've indicated that this security control was validated at your last formal assessment or certification event.`*/}
      //             {/*        : "You've indicated that this security control was not validated at your last formal assessment or certification event."}*/}
      //             {/*>*/}
      //             {/*<span>*/}
      //             {/*    {params.getValue('lastAssessment')*/}
      //             {/*        ? <BBIconChecklistSecurityLock className={"text-success"} />*/}
      //             {/*        : <BBIconRiskDirectionDown className={"text-danger"} />*/}
      //             {/*    }*/}
      //             {/*</span>*/}
      //             {/*</Tooltip>*/}
      //             <Tooltip
      //                 title={params.getValue('selfAssessment')
      //                     ? `You've indicated that this security control was validated at your last informal self-assessment.`
      //                     : "You've indicated that this security control was not validated at your last informal self-assessment."}
      //             >
      //             <span>
      //                 {params.getValue('selfAssessment')
      //                     ? <BBIconChecklistSecurityLock className={"text-success"} />
      //                     : <BBIconRiskDirectionDown className={"text-danger"} />
      //                 }
      //             </span>
      //             </Tooltip>
      //             {/*<Tooltip*/}
      //             {/*    title={params.getValue('thirdPartyAssessment')*/}
      //             {/*        ? `You've indicated that this security control was validated by a third-party.`*/}
      //             {/*        : "You've indicated that this security control was not validated by a third-party."}*/}
      //             {/*>*/}
      //             {/*<span>*/}
      //             {/*    {params.getValue('thirdPartyAssessment')*/}
      //             {/*        ? <BBIconChecklistSecurityLock className={"text-success"} />*/}
      //             {/*        : <BBIconRiskDirectionDown className={"text-danger"} />*/}
      //             {/*    }*/}
      //             {/*</span>*/}
      //             {/*</Tooltip>*/}
      //         </>
      //     ),
      // },

      // { field: 'lastAssessment', headerName: 'Last Assessment', hide: true, sortable: true, type: 'string', flex: 1,
      //     renderCell: (params) => (
      //         <Tooltip
      //             title={params.value
      //                 ? `You've indicated that this security control was validated at your last formal assessment or certification event.`
      //                 : "You've indicated that this security control was not validated at your last formal assessment or certification event."}
      //         >
      //             <span>
      //                 {params.value
      //                     ? <BBIconChecklistSecurityLock className={"text-success"} />
      //                     : <BBIconRiskDirectionDown className={"text-danger"} />
      //                 }
      //             </span>
      //         </Tooltip>
      //     ),
      // },
      { field: 'selfAssessment', headerName: 'Self Assessment', cellClassName: "bbTourSelfAssessmentControl", hide: false, sortable: true, type: 'string', width: 150,
          renderCell: (params) => (
              <ComplianceAssessmentToggleSwitch
                  customerId={params.row.customerId}
                  controlId={params.row.id}
                  assessmentSourceId={1}
                  complianceStandardId={complianceStandardId}
              />
          ),
      },
      { field: 'lastSelfAssessmentDate', headerName: 'Assessed', hide: false, sortable: true, type: 'date', width: 115,
          renderCell: (params) => (
              renderCellExpand(params, <Tooltip
                      title={`This assessment was last updated ${params.value ? bbFormattedDateString(params.value, "long") : null} by ${params.row.lastSelfAssessmentBy}`}
                  >
                  <span>
                      {params.value ? bbFormattedDateString(params.value, "short") : null}
                  </span>
                  </Tooltip>

              )

          ),
      },
      { field: 'lastSelfAssessmentBy', headerName: 'By', hide: true, sortable: true, type: 'string', flex: 1.1,
          renderCell: (params) => (
              <Tooltip
                  title={`${params.value}`}
              >
                  <span>
                      {params.value}
                  </span>
              </Tooltip>
          ),
      },
      // { field: 'thirdPartyAssessment', headerName: 'Third-Party Assessment', hide: true, sortable: true, type: 'string', flex: 1,
      //     renderCell: (params) => (
      //         <Tooltip
      //             title={params.value
      //                 ? `You've indicated that this security control was validated by a third-party.`
      //                 : "You've indicated that this security control was not validated by a third-party."}
      //         >
      //             <span>
      //                 {params.value
      //                     ? <BBIconChecklistSecurityLock className={"text-success"} />
      //                     : <BBIconRiskDirectionDown className={"text-danger"} />
      //                 }
      //             </span>
      //         </Tooltip>
      //     ),
      // },


      { field: 'bbAttestations', headerName: ' ', cellClassName: "bbTourStepBBAttestations", hide: false, width : 75, sortable: true, type: 'string',
          valueGetter: (params) => (
              params.row.canBBVerify
          ),
          renderCell: (params) => (
              <>

                  <Tooltip
                      title={params.row.canBBSatisfy ? `BreachBits is capable of satisfying this control. BreachBits is satisfying this security control for you.` : "BreachBits cannot satisfy this control. Implement another control in order to satisfy this compliance requirement."}
                  >
                  <span>
                      {params.row.canBBSatisfy
                          ? <BBIconShieldCheck className={"text-success"}/>
                          : params.row.isBBFutureSatisfy
                              ? <BBIconConstructionCone className={"text-light-gray"}/>
                              : <BBIconShieldCheck className={"text-light-gray"}/>
                      }
                  </span>
                  </Tooltip>
                  <Tooltip
                      title={(params.row.canBBVerify ? `BreachBits can verify this control.` : params.row.isBBFutureVerify ? "Verification for this control by BreachBits is coming soon!" : "BreachBits cannot verify this control.") + " Verification is an automated service where BreachBits attempts to detect if this security control is being enforced by another security tool using direct and indirect measurements."}
                  >
                  <span>
                      {params.row.canBBVerify
                          ? <BBIconSextantMeasure className={"text-success"} />
                          : params.row.isBBFutureVerify
                              ? <BBIconConstructionCone className={"text-light-gray"}/>
                              : <BBIconSextantMeasure className={"text-light-gray"}/>
                      }
                  </span>
                  </Tooltip>
              </>
          ),
              },

      { field: 'canBBSatisfy', headerName: 'Satisfy', hide: true, sortable: true, type: 'string', width: 75,
          renderCell: (params) => (
              <Tooltip
                  title={params.row.canBBSatisfy ? `BreachBits is capable of satisfying this control. BreachBits is satisfying this security control for you.` : "BreachBits cannot satisfy this control. Implement another control in order to satisfy this compliance requirement."}
              >
                  <span>
                      {params.row.canBBSatisfy
                          ? <BBIconShieldCheck className={"text-success"}/>
                          : params.row.isBBFutureSatisfy
                              ? <BBIconConstructionCone className={"text-light-gray"}/>
                              : <BBIconShieldCheck className={"text-light-gray"}/>
                      }
                  </span>
              </Tooltip>
          ),
      },
      { field: 'canBBVerify', headerName: 'Verify', hide: true, sortable: true, type: 'string', width: 75,
          renderCell: (params) => (
              <Tooltip
                  title={(params.row.canBBVerify ? `BreachBits can verify this control.` : params.row.isBBFutureVerify ? "Verification for this control by BreachBits is coming soon!" : "BreachBits cannot verify this control.") + " Verification is an automated service where BreachBits attempts to detect if this security control is being enforced by another security tool using direct and indirect measurements."}
              >
                  <span>
                      {params.row.canBBVerify
                          ? <BBIconSextantMeasure className={"text-success"} />
                          : params.row.isBBFutureVerify
                              ? <BBIconConstructionCone className={"text-light-gray"}/>
                              : <BBIconSextantMeasure className={"text-light-gray"}/>
                      }
                  </span>
              </Tooltip>
          ),
      },


  ];

    //peel the state data into a form the dataTable can read
  const tableData = cmmcStandardControls ? mapObject(cmmcStandardControls, (key, control) => {
    // console.log("controls data table cmmc looking at ", key, control);
      const assessments = customers ? customerAssessments ? customerAssessments[customerId] ? customerAssessments[customerId] : null : null : null;
      // //assessment group are all of the recent assessments. should contain last official, last self, and last third-pary assessment
      // const assessmentGroup = bbIsObject(assessments) ? bbIsObject(assessments[complianceStandardId]) ? bbIsObject(assessments[complianceStandardId][control.Id]) ? assessments[complianceStandardId][control.Id] : null : null : null;
      const lastSelfAssessmentMeta = bbExtractLastAssessmentDateAndBy(assessments, complianceStandardId, control.Id, 1);
      return (
        {

            // "f384f147-40b6-48cf-9c46-7421286a136e": {
            //     "Id": "f384f147-40b6-48cf-9c46-7421286a136e",
            //     "Name": "Define procedures for the handling of CUI data.",
            //     "Standard": "Cybersecurity Maturity Model Certification (CMMC)",
            //     "Category": "Asset Management",
            //     "Subcategory": "Identify and document assets",
            //     "Level": {
            //         "Id": "2c070f33-28f3-4e72-8c1d-1284a91e45a6",
            //         "Name": "Maturity Level 3",
            //         "Abbreviation": "ML3",
            //         "Description": "Good cyber hygiene. Level 3 focuses on the protection of CUI and encompasses all of the security requirements specified in NIST SP800-171 as well as additional practices from other standards and references to mitigate threats.",
            //         "Terminology": "Maturity Level"
            //     },
            //     "Verification Available": false,
            //     "Terminology": "Practice",
            //     "Standard Control Id": "AM.3.036"
            // }
            id: control.Id,
            standardControlId: control["Standard Control Id"],
            terminology: control.Terminology,
            levelAbbreviation: control.Level.Abbreviation ? control.Level.Abbreviation : "",
            levelName: control.Level.Name,
            levelDescription: control.Level.Description,
            category: control.Category,
            subcategory: control.Subcategory,
            name: control.Name,


            // lastAssessment: true,
            selfAssessment: bbExtractAssessmentScore(assessments, complianceStandardId, control.Id, 1),
            lastSelfAssessmentDate: lastSelfAssessmentMeta ? lastSelfAssessmentMeta.lastAssessedDate : null,
            lastSelfAssessmentBy: lastSelfAssessmentMeta ? lastSelfAssessmentMeta.lastAssessedBy : null,
            customerId: customerId,
            assessments: assessments,
            // thirdPartyAssessment: false,

            canBBVerify: control["Verification Available"],
            isBBFutureVerify: control.hasOwnProperty("Verification Coming Soon") ? control["Verification Coming Soon"] : null,
            canBBSatisfy: control["BreachBits Satisfies"],
            isBBFutureSatisfy: control.hasOwnProperty("BreachBits Will Satisfy") ? control["BreachBits Will Satisfy"] : null,

        }
    )
  }) : null;

    const tableDataAsArray = () => {
        // console.log("Creating humansTableData as array from humanTableData ", tableData);
        let arr=[];
        for (let ob in tableData) {
            // console.log("ob is ", tableData[ob])
            arr.push(tableData[ob]);
        }
        // console.log("resulting array ", arr);
        return arr;
    }

    const calcProgressValue = () => {

        // return !loadingVectors ? 100 : 0;
        if (!loadingComplianceStandards && bbIsObject(cmmcStandardControls)) {
            return 100
        } else {
            return 0
        }
    }

    const calcBufferValue = () => {
        // if (totalNumAttacks === 0){
        //     return 100;
        // } else if (!totalNumAttacks || !tableData) {
        //     return 50;
        // } else {
        //     return (Object.keys(tableData).length + 10) / totalNumAttacks * 100;
        // }

        if (loadingComplianceStandards && !Object.keys(cmmcStandardControls).length) {
            return 50
        } else if (!loadingComplianceStandards && !bbIsObject(cmmcStandardControls)) {
            return 0
        } else {
            return 100
        }
    }

    const calcLoadingState = () => {
        // if (totalNumAttacks === 0){
        //     return false;
        // } else if (Object.keys(tableData).length === 0) {
        //     return true;
        // } else {
        //     return false;
        // }

        if (loadingComplianceStandards) {
            return true
        } else {
            return false
        }
    }

    return (
        <div >
            <BBDataTable
                columns={userTableHeadings}
                rows={tableData ? tableDataAsArray() : []}
                totalRows={cmmcStandardControls ? Object.keys(cmmcStandardControls).length : 0}
                progressValue={calcProgressValue()}
                bufferValue={calcBufferValue()}
                title={title}
                loading={calcLoadingState()}
                rowsPerPageOptions = {[25, 50, 100, 250, 500]}
                defaultPageSize = {100}
                defaultSortModel = {[
                    {
                        field: 'standardControlId',
                        sort: 'asc',
                    }

                ]}
                />
        </div>
    );



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
    complianceStandardId: PropTypes.string.isRequired,
    tableTitle: PropTypes.oneOfType(
        [PropTypes.string,
        PropTypes.object,]
    ).isRequired,

    tableTip: PropTypes.oneOfType(
        [PropTypes.string,
        PropTypes.object,]
    ).isRequired,
};

export default TableContainer